export const Notifications = {
    Crud: 'ClientFactory:CRUD'
};
//# sourceMappingURL=notifications.js.map